import { Injectable } from '@angular/core';

import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';

import { Observable } from 'rxjs/observable';
import { HttpInterceptorHandler } from '@angular/common/http/src/interceptor';

import { AuthService } from './auth.service';

@Injectable()
export class HsbServicesAuthInterceptor implements HttpInterceptor{
    constructor(private authService: AuthService){

    }

    intercept(req: HttpRequest<any>, next: HttpHandler): 
        Observable<HttpEvent<any>>{

            if(this.authService.credentials &&
                this.authService.credentials.accessToken){
                    
                    // const authReq = req.clone({
                    //     headers: req.headers.set('Authorization', 'token  a1f9fc71802580604cbfed334cc6ec848a6254a2')
                    // });
                    
                    //inser access token.

                    const authReq = req.clone({
                        headers: req.headers.set('x-access-token', this.authService.credentials.accessToken)
                    });

                    return next.handle(authReq);
            }
        


        return next.handle(req);

    }

}



// WEBPACK FOOTER //
// ./src/app/hsbservicesauth.interceptor.ts